import * as sentry from '@sentry/react';
import {call, put, takeLatest} from 'redux-saga/effects';

import {fetchUserPoints} from 'services/campaign/campaign-service';
import {fetchUserPointsAction, setExpiringPointsAction} from 'store/actions/campaign-action';
import {GetUserPointsResponse} from 'types/campaign';

// HY TODO: move all other campaign related items here to reduce bloating the basket
function* fetchUserPointsSaga(): Generator {
  try {
    const response = (yield call(() => fetchUserPoints())) as GetUserPointsResponse;

    yield put(setExpiringPointsAction(response.expiringPoints));
  } catch (e: any) {
    sentry.captureException(e);
    yield put(setExpiringPointsAction());
  }
}

export default function* () {
  yield takeLatest(fetchUserPointsAction, fetchUserPointsSaga);
}
